// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2488760e","507":"100e863f"}[chunkId] + ".chunk.js";
};